import { useEffect } from 'react';
import API from '../API';
import { roomPrivacySnapshot } from '../components/UnityGame/roomPrivacy';

/** Keep the authored privacy barriers synchronized, including booking start/end transitions. */
export function useRoomPrivacy(accessToken: string | null | undefined, eventId: string, ready: boolean) {
  useEffect(() => {
    if (!ready || !accessToken) return;
    let disposed = false;
    let pending = false;
    const refresh = async () => {
      if (pending || disposed) return;
      pending = true;
      try {
        const response = await API.getBookings(accessToken, eventId);
        if (!response.ok) throw new Error(`Booking privacy: ${response.status}`);
        const data = await response.json();
        // Go serializes an empty booking slice as null.
        if (data.bookings !== null && !Array.isArray(data.bookings)) throw new Error('Invalid booking privacy response');
        if (!disposed) window.sendMessageToUnity?.('BrowserBridge', 'ReceivePayload', JSON.stringify({
          eventType: 'RoomPrivacySnapshot', payload: JSON.stringify(roomPrivacySnapshot(data.bookings || [])),
        }));
      } catch (error) {
        // Retain the last known schedule; never turn a fetch failure into "all rooms public".
        if (!disposed) console.warn('[RoomPrivacy] Could not refresh booking privacy', error);
      } finally { pending = false; }
    };
    void refresh();
    const timer = window.setInterval(refresh, 5000);
    window.addEventListener('focus', refresh);
    return () => { disposed = true; window.clearInterval(timer); window.removeEventListener('focus', refresh); };
  }, [accessToken, eventId, ready]);
}
